var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Button } from "@savvyinsure/react-ui";
import ConnectButton from "./connect-ui/Button";
import Container from "./connect-ui/Container";
import RouteTitle from "./RouteTitle";
import classNames from "classnames";
import useAppSelector from "../hooks/useAppSelector";
import { useHistory } from "react-router-dom";
function OptionFormItem(_a) {
    var id = _a.id, label = _a.label, nextPhase = _a.nextPhase, redirectLink = _a.redirectLink, onSelect = _a.onSelect, rest = __rest(_a, ["id", "label", "nextPhase", "redirectLink", "onSelect"]);
    var push = useHistory().push;
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration.isSavvyWidget; });
    function handleClick() {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect();
        if (nextPhase) {
            push(nextPhase);
        }
        if (redirectLink) {
            window.open(redirectLink, "_blank");
        }
    }
    return isSavvyWidget ? (React.createElement(Button, { id: id, type: "button", onClick: handleClick }, label)) : (React.createElement(ConnectButton, __assign({ id: id, type: "button", onClick: handleClick }, rest), label));
}
export function OptionForm(_a) {
    var submitId = _a.submitId, options = _a.options, prompt = _a.prompt, footer = _a.footer;
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration.isSavvyWidget; });
    return (React.createElement(Container, { className: "grow pb-8" },
        prompt ? (React.createElement(RouteTitle, { className: classNames("mb-6 font-bold", {
                "min-h-[48px] text-black-100 md:min-h-[56px]": isSavvyWidget,
                "xs-max:text-[22px] xs-max:leading-tight": !isSavvyWidget,
            }) }, prompt)) : null,
        React.createElement("div", { className: classNames("flex w-full flex-col", {
                "space-y-2": isSavvyWidget,
                "space-y-4": !isSavvyWidget,
            }) }, options === null || options === void 0 ? void 0 : options.map(function (option, index) { return (React.createElement("div", { key: option.label, className: "w-full" },
            React.createElement(OptionFormItem, { id: "".concat(submitId, "-").concat(index), label: option.label, redirectLink: option.redirectLink, nextPhase: option.nextPhase, onSelect: option.onSelect }))); })),
        footer ? (React.createElement("div", { className: "mt-auto text-center text-sm leading-none text-gray-100" }, footer)) : null));
}
